import NeverKnowinglyUndersoldComponent from "./NeverKnowinglyUndersoldComponent";
export default class PurchaseDetailsAndCustomerDetails extends NeverKnowinglyUndersoldComponent {
  constructor() {
    super(document.querySelector("#rest-of-form"));

    this.notPurchasedInputs = [
      document.querySelector("#product-details--purchase-date"),
      document.querySelector("#product-details--order-number"),
      document.querySelector("#product-details--jl-product-code"),
      document.querySelector("#product-details--name"),
      document.querySelector("#product-details--jl-price"),
      document.querySelector("#product-details--competitor-price"),
      document.querySelector("#your-details--title"),
      document.querySelector("#your-details--first-name"),
      document.querySelector("#your-details--last-name"),
      document.querySelector("#your-details--telephone"),
      document.querySelector("#your-details--email"),
      document.querySelector("#your-details--postcode"),
    ];
  }

  render(state) {
    if (state.isJLOnlinePurchased && state.alreadyPurchased) {
      this.show();
      this.notPurchasedInputs.forEach((i) => {
        if (i) {
          i.disabled = false;
        }
      });
    } else {
      this.hide();
      this.notPurchasedInputs.forEach((i) => {
        if (i) {
          i.disabled = true;
        }
      });
      const messageArea = document.querySelector("#feedback-messages");
      if (messageArea) {
        messageArea.classList.add("u-hidden");
        messageArea.setAttribute("aria-hidden", "true");
      }
      const inputs = document.querySelectorAll(".input--invalid");
      if (inputs.length > 0) {
        inputs.forEach((input) => {
          input.classList.remove("input--invalid");
          input.classList.add("input--valid");
        });
        document
          .querySelectorAll(".never-knowingly-undersold-error-msg")
          .forEach((e) => e.parentNode.removeChild(e));
      }
    }
  }
}
